var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnectIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10742 15.8938C5.27285 17.0593 6.75771 17.8529 8.37422 18.1745C9.99074 18.4961 11.6663 18.331 13.189 17.7003C14.7118 17.0696 16.0133 16.0015 16.9289 14.6311C17.8446 13.2607 18.3334 11.6495 18.3334 10.0013C18.3334 8.35312 17.8446 6.74195 16.9289 5.37154C16.0133 4.00112 14.7118 2.93302 13.189 2.30229C11.6663 1.67157 9.99074 1.50655 8.37422 1.82811C6.75771 2.14966 5.27285 2.94335 4.10742 4.10881",
    stroke: "white",
    strokeWidth: 1.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 10L13.1503 9.47917L13.567 10L13.1503 10.5208L12.5003 10ZM2.50033 10.8333C2.27931 10.8333 2.06735 10.7455 1.91107 10.5893C1.75479 10.433 1.66699 10.221 1.66699 10C1.66699 9.77899 1.75479 9.56702 1.91107 9.41074C2.06735 9.25446 2.27931 9.16667 2.50033 9.16667V10.8333ZM9.81699 5.3125L13.1503 9.47917L11.8503 10.5208L8.51699 6.35417L9.81699 5.3125ZM13.1503 10.5208L9.81699 14.6875L8.51699 13.6458L11.8503 9.47917L13.1503 10.5208ZM12.5003 10.8333H2.50033V9.16667H12.5003V10.8333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectIcon);
export default __webpack_public_path__ + "static/media/connect-icon.7b57b1070a0b8304249e53b5b0a27ada.svg";
export { ForwardRef as ReactComponent };